import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CurrencyWidget, Currency, Carousel } from '@code/innovance-react-ui-kit';

import CampaignBanner, { CampaignBannerItem } from 'src/front/components/CampaignBanner';

import { ExchangeRate } from 'src/front/api/apiInstance';
import * as Api from 'src/front/api/generated';
import { BREAK_POINTS } from 'src/front/constant';

import slideBackImage from 'src/front/assets/images/slide-back.jpg';
import cardCreditImage from 'src/front/assets/images/pic-card_credit.png';
import cardDebitImage from 'src/front/assets/images/pic-card_debit.png';

// TODO (ramazanguclu) Unnecessary importing style should be already imported by component library
// TODO (ramazanguclu) after searching delete slick-carousel from the package.json
import 'slick-carousel/slick/slick.css';

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) {
    display: block;
    margin-bottom: 35px;
  }
`;

const CarouselWrapper = styled.div`
  width: calc(100% - 455px);

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) {
    width: 100%;
  }
`;

const CurrenciesWrapper = styled.div`
  margin-right: 35px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) {
    margin-top: 35px;
    margin-right: 0;

    & > div {
      width: 100%;
    }
  }
`;

const Dashboard: FC = () => {
  const { t } = useTranslation();
  const [currencies, setCurrencies] = useState<Api.ExchangeRate[]>([]);

  const loadExchangeRate = async (): Promise<void> => {
    try {
      const { data } = await ExchangeRate.getExchangeRate();

      setCurrencies(data.exchangeRateList);
    } catch (data) {
      // TODO: (ramazanguclu) error handling
    }
  };

  useEffect(() => {
    loadExchangeRate();
  }, []);

  const mapCurrencies = currencies.map((item: Api.ExchangeRate, index: number) => ({
    id: index,
    currencyType: item.exchangeType,
    buy: item.purchase,
    sell: item.sale,
  }));

  const campaignBannerItems: CampaignBannerItem[] = [
    {
      background: slideBackImage,
      image: cardDebitImage,
      title: 'dashboard_banner_cardPlus_title',
      description: 'dashboard_banner_cardPlus_text',
      id: 'CARD PLUS',
      buttonText: t('dashboard_banner_cardPlus_button'),
      link: 'https://www.crediteurope.ru/privately/raschetnye_karty/',
    },
    {
      background: slideBackImage,
      image: cardCreditImage,
      title: 'dashboard_banner_cardCreditPlus_title',
      description: 'dashboard_banner_cardCreditPlus_text',
      id: 'CARD CREDIT PLUS',
      buttonText: t('dashboard_banner_cardCreditPlus_button'),
      link: 'https://www.crediteurope.ru/privately/credit_cards/',
    },
  ];

  return (
    <Container>
      <CarouselWrapper>
        <Carousel>
          {campaignBannerItems.map((item: CampaignBannerItem) => (
            <CampaignBanner key={item.id} item={item} />
          ))}
        </Carousel>
      </CarouselWrapper>
      <CurrenciesWrapper>
        <CurrencyWidget
          buyTitle={t('dashboard_buy_currency_title')}
          currencies={mapCurrencies as Currency[]}
          height={300}
          sellTitle={t('dashboard_sell_currency_title')}
        />
      </CurrenciesWrapper>
    </Container>
  );
};

export default Dashboard;
